<modulo posicao="banner-slider"></modulo> 
<modulo posicao="eventos"></modulo> 
<modulo posicao="chamada"></modulo> 
<modulo posicao="visao"></modulo>  
<modulo posicao="podcast"></modulo>  
<div id="section-cultos">
    <modulo posicao="horarios-de-culto"></modulo>  
</div>
  
